/**
 * Contacts leave the phone only as SHA-256 hashes, in the normal forms migration 167 hashes profile_private with:
 * email trimmed and lower-cased; phone as digits only, the last 10.
 */
export function normalEmail(e) {
  const v = String(e || '')
    .trim()
    .toLowerCase();
  return v.includes('@') ? v : null;
}

export function normalPhone(p) {
  const d = String(p || '').replace(/\D/g, '');
  return d.length >= 10 ? d.slice(-10) : null;
}

export async function sha256Hex(text) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

/** [{ name, emails, phones }] -> { hashes: string[], byHash: Map(hash -> contact index) } */
export async function hashContacts(contacts) {
  const byHash = new Map();
  await Promise.all(
    contacts.map(async (c, i) => {
      const keys = [
        ...(c.emails || []).map(normalEmail),
        ...(c.phones || []).map(normalPhone),
      ].filter(Boolean);
      for (const k of keys) byHash.set(await sha256Hex(k), i);
    }),
  );
  return { hashes: [...byHash.keys()], byHash };
}
